const STORAGE_KEY = "lanis_custom_lenders";

function getCustomLenders() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
}

export function addCustomLender(name, builtInLenders = []) {
  if (!name || !name.trim()) return;
  const trimmed = name.trim();
  const allExisting = [...builtInLenders, ...getCustomLenders()];
  if (allExisting.some(l => l.toLowerCase() === trimmed.toLowerCase())) return;
  const customExisting = getCustomLenders();
  const updated = [...customExisting, trimmed].sort((a, b) =>
    a.localeCompare(b, undefined, { sensitivity: "base" })
  );
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  } catch {
    // localStorage unavailable
  }
}

export function getAllLenders(builtInLenders) {
  const custom = getCustomLenders();
  return [...builtInLenders, ...custom].sort((a, b) =>
    a.localeCompare(b, undefined, { sensitivity: "base" })
  );
}
